import styled, { css } from "styled-components";
import TextGothic from "./utils/TextGothic";
import arrow from "./../images/arrow_forward.svg";
import { PlacelistType } from "../resources/placelists";
import { Link } from "react-router-dom";
import { colorCode } from "../resources/colors";
import { media } from "utils/media";
import { theme } from "utils/theme";

type PlacelistItemProps = {
  placelist: PlacelistType;
  index: number;
};

const PlacelistItem = (props: PlacelistItemProps) => {
  const { placelist, index } = props;
  const isReversed: boolean = index % 2 === 1;

  return (
    <Wrapper isReversed={isReversed}>
      <ImgWrapper isReversed={isReversed}>
        <ArtistImg
          src={`/domtour/theme/workation/music/images/${placelist.id}/artist.jpg`}
          alt="artist"
        />
      </ImgWrapper>
      <Content>
        <TextGothic size="20px" lh={1.5} as="h2">
          {placelist.title}
        </TextGothic>
        <Composer>
          Composed by{" "}
          <Name size="16px" lh={1.5}>
            {placelist.artists.join("、")}
          </Name>
        </Composer>
        <Introduction>{placelist.about}</Introduction>
        <Button href={`/ja/jp/domtour/theme/workation/music/${placelist.id}`}>
          <TextGothic size="16px">プレイスリストを見る</TextGothic>
          <ArrowVisible>
            <Arrow src={arrow} />
          </ArrowVisible>
        </Button>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ isReversed: boolean }>`
  ${media.sp`
    padding: 32px 20px;
  `}
  ${(props) => media.pc`
    &:not(:last-child) {
      padding-bottom: 80px;
    }
    max-width: 960px;
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    flex-direction: ${props.isReversed ? "row-reverse" : "row"};
  `}
`;

const ImgWrapper = styled.div<{ isReversed: boolean }>`
  position: relative;
  overflow: hidden;
  ${media.sp`
    width: 100%;
    height: calc((100vw - 40px) * ${theme.spArtistImgAspect});
    margin-bottom: 16px;
  `}
  ${(props) => media.pc`
    width: 450px;
    height: calc(450px * ${theme.pcArtistImgAspect});
    ${
      props.isReversed
        ? css`
            margin-left: 80px;
          `
        : css`
            margin-right: 80px;
          `
    }
  `}
`;

const ArtistImg = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  font-family: "object-fit: cover;";
  object-position: center center;
  vertical-align: top;
`;

const Content = styled.div`
  ${media.pc`
    width: 430px;
  `}
`;

const Composer = styled.div`
  font-size: 14px;
  margin: 8px 0;
`;

const Name = styled(TextGothic)`
  display: inline-block;
`;

const Introduction = styled.div`
  margin: 16px 0;
`;

const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colorCode.baseGreen};
  padding: 12px 0;
  border-bottom: solid 0.5px #a7ce88;
  text-decoration: none;
  cursor: pointer;
  transition: ease-out 200ms;
  &:hover {
    color: ${colorCode.dimGreen};
  }
`;

const ArrowVisible = styled.div`
  width: 24px;
  height: 24px;
  overflow: hidden;
  position: relative;
`;

const Arrow = styled.img`
  height: 24px;
  width: 44px;
  position: absolute;
  top: 0;
  left: -20px;
  transition: ease-out 200ms;
  ${Button}:hover & {
    left: 0;
  }
`;

export default PlacelistItem;
